// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1997) return "css/1997-9de04d3e.css";
	// return url for filenames based on template
	return "css/" + chunkId + "-" + "67ef751d" + ".css";
};